import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.secondary.main,
    padding: "20px",
  },
  text: {
    color: "#fff",
    textAlign: "center",
  },
}));

function Footer({}) {
  const classes = useStyles();
  return (
    <div className={classes.footer}>
      <p className={classes.text}>Versus.com &copy; Copyright 2020</p>
    </div>
  );
}
export default React.memo(Footer);
